<div class="wrapper">
  <div class="authentication-reset-password d-flex align-items-center justify-content-center">
    <div class="">
      <div class="">
        <div class="card">
          <div class="row">
            <div class="col-lg-8 border-end">
              <img src="assets/images/login-images/welder.jpeg" class="card-img login-img h-100"
              alt="...">
            </div>
            <div class="col-lg-4 ">
              <div class="card-body">
                <div class="p-5">
                  <div class="text-center">
                    <img src="assets/images/logo-img.png" width="180" alt="">
                  </div>
                  <h4 class="mt-5 font-weight-bold">Login</h4>
                  <p class="text-muted">Welcome to Kenya Association of Manufacturers Portal. Login to access our services</p>
                  <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error|json}}</div>
                  <form class="row g-3" [formGroup]="signinForm" autocomplete="off">
                    <div class="col-12">
                      <label for="inputLastEnterUsername" class="form-label">Enter Email</label>
                      <div class="input-group"> <span class="input-group-text bg-transparent"><i
                            class='bx bxs-user'></i></span>
                        <input type="text" class="form-control border-start-0" formControlName="userName"
                          [ngClass]="{ 'is-invalid': submitted && f.userName.errors }" placeholder="Enter Username"
                          id="inputLastEnterUsername" />
                      </div>
                      <div *ngIf="f.userName.touched && f.userName.invalid" class="text-danger">
                        <div *ngIf="f.userName.errors?.required">Username is required.</div>
                      </div>
                    </div>
                    <div class="col-12">
                      <label for="inputLastEnterPassword" class="form-label">Enter Password</label>
                      <div class="input-group"> <span class="input-group-text bg-transparent"><i
                            class='bx bxs-lock-open'></i></span>
                        <input type="password" class="form-control border-start-0" formControlName="password"
                          [ngClass]="{ 'is-invalid': f.submitted && f.password.errors }" placeholder="Enter Password"
                          id="inputLastEnterPassword" />
                      </div>
                      <div *ngIf="f.password.touched && f.password.invalid" class="text-danger">
                        <div *ngIf="f.password.errors?.required">Password is Empty.</div>
                      </div>
                    </div>
                    <!-- <div class="col-md-6">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="gridCheck3">
                        <label class="form-check-label" for="gridCheck3">Remember Me</label>
                      </div>
                    </div> -->
                    <div class="col-md-12 text-center"> <a routerLink="/forgot-password"
                        (click)="$event.preventDefault()">Activate Account/Reset Password</a>
                    </div>
                    <div class="col-12">
                      <div class="d-grid">
                        <button type="button" [disabled]="loading" (click)="login()" [disabled]="!signinForm.valid"
                          class="btn btn-primary btn-lg px-5"><i class='bx bxs-lock-open'></i>
                          <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                          Login
                        </button>
                      </div>
                    </div>
                  </form>
                  <hr />
                  <div class="col-12 text-center">
                    <a routerLink="/sign-up" class="mb-0">Not a member? Sign Up for Membership</a>
                  </div>
                  <!-- <hr />
                  <div class="col-12 text-center">
                    <a routerLink="/non-members-sign-up" class="mb-0">Non Members Sign Up</a>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
